module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Import articles","importFromSite":"Import from site","all":"All","withoutRemote":"Without a remote article"}}')
  delete Component.options._Ctor
}
